import SBEditable from "../../../components/sbEditable/sbEditable";
import ListingHeader from "../../../components/listingHeader/listingHeader";
import ArticleListingCard from "../../../components/articleListingCard/articleListingCard";
import RouterLink from "../../../components/link/RouterLink";

import { useStoryblokLatestNewsWidget } from "../../../hooks/useStoryblokLatestNewsWidget";

import styles from "./latestNewsWidget.module.scss";
import { FormattedMessage } from "react-intl";

/// >> Blok:latestnewsasidewidget
// headline:text
function LatestNewsWidget({ blok }) {
  const [articleList, isLoading] = useStoryblokLatestNewsWidget();

  if (!isLoading && articleList.length === 0) {
    return null;
  }

  return (
    <SBEditable blok={blok} withClass={styles.root}>
      <ListingHeader withClass={styles.listingHeader}>
        <h2>
          <FormattedMessage id="component.latest_news_widget.headline" />
        </h2>
      </ListingHeader>
      <ul className={styles.wrapper}>
        {articleList.map((a) => {
          return (
            <li key={a.uuid}>
              <ArticleListingCard
                layout="noImage_article_type"
                date_new_line={true}
                link_uuid={a.uuid}
                slug={a.slug}
                thumbnail={a.content.thumbnail}
                authors={a.content.authors}
                title={a.content.headline}
                date={a.content.article_date}
                article_category={a.content.category}
                article_type={a.content.article_type}
                comment_count={5}
                enable_comments={a.content.has_comments}
                enable_social_sharing={a.content.has_social_sharing}
                use_legacy_thumbnail_background={
                  a.content.legacy_thumbnail_background
                }
              />
            </li>
          );
        })}
      </ul>
      <div className={styles.asideCTA}>
        <RouterLink to="/latest" className="btn btn-scooter-outline">
          <FormattedMessage id="component.latest_news_featured_widget.all_button" />
        </RouterLink>
      </div>
    </SBEditable>
  );
}

export default LatestNewsWidget;
